import apiClient from '@src/api/clients';

const buildQueryString = (params = {}) => {
  const entries = Object.entries(params).filter(
    ([, value]) => value !== undefined && value !== null && value !== ''
  );
  if (!entries.length) {
    return '';
  }
  const search = new URLSearchParams(entries).toString();
  return search ? `?${search}` : '';
};

const emailMappingsApi = {
  list(params = {}) {
    const queryString = buildQueryString(params);
    return apiClient.request({
      url: `app1/email-mappings/${queryString}`,
      method: 'GET',
    });
  },
  retrieve(id) {
    return apiClient.request({
      url: `app1/email-mappings/${id}/`,
      method: 'GET',
    });
  },
  create(payload) {
    return apiClient.request({
      url: 'app1/email-mappings/',
      method: 'POST',
      payload,
    });
  },
  update(id, payload) {
    return apiClient.request({
      url: `app1/email-mappings/${id}/`,
      method: 'PUT',
      payload,
    });
  },
  destroy(id) {
    return apiClient.request({
      url: `app1/email-mappings/${id}/`,
      method: 'DELETE',
    });
  },
  metadata() {
    return apiClient.request({
      url: 'app1/email-mappings/metadata/',
      method: 'GET',
    });
  },
  run(id) {
    return apiClient.request({
      url: `app1/email-mappings/${id}/run/`,
      method: 'POST',
    });
  },
};

export default emailMappingsApi;
